import OraculoPage from './pages/OraculoPage';

function App() {
    return <OraculoPage />;
}

export default App;
